<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
            <el-breadcrumb-item>额度购买退款</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-input placeholder="订单号" clearable v-model="queryInfo.orderNo" @clear="getList()" style="width: 200px;">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                    <el-select v-model="queryInfo.storeId" clearable filterable placeholder="选择门店" style="margin-left: 10px; width: 180px" @change="getList()">
                        <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select>
                    <el-date-picker
                        v-model="dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="退款开始"
                        end-placeholder="退款结束"
                        value-format="yyyy-MM-dd"
                        @change="onDateChange"
                        style="margin-left: 10px"
                    >
                    </el-date-picker>
                    <el-button type="primary" icon="el-icon-upload2" @click="exportExcel" :loading="exporting" v-permission="'btn:order:quotabuyrefunds:export'" style="margin-left: 10px;">
                        导出Excel
                    </el-button>
                </el-col>
            </el-row>
            <br>
            <el-table :data="list" style="width: 100%" stripe size="middle" height="700">
                <el-table-column label="退款单号" prop="refundNo" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="原订单号" prop="orderNo" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="门店" prop="storeName" width="160" show-overflow-tooltip></el-table-column>
                <el-table-column label="卡种" prop="cardTypeName" width="90"></el-table-column>
                <el-table-column label="张数" prop="count" width="70"></el-table-column>
                <el-table-column label="订单金额" prop="amount" width="90"></el-table-column>
                <el-table-column label="退款金额" prop="refundAmount" width="90"></el-table-column>
                <el-table-column label="退款状态" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.refundStatus == 1" type="success">{{ scope.row.refundStatusText }}</el-tag>
                        <el-tag v-else type="danger">{{ scope.row.refundStatusText }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="退款原因" prop="refundReason" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作人" prop="operator" width="100"></el-table-column>
                <el-table-column label="退款时间" width="175">
                    <template slot-scope="scope">{{ scope.row.createTime | dateFormat }}</template>
                </el-table-column>
            </el-table>
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum" :page-sizes="[20, 50, 100]" :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>
<script>
import axios from "axios";
import { saveAs } from "file-saver";
import { Loading } from "element-ui";

export default {
    data() {
        return {
            queryInfo: {
                orderNo: '',
                storeId: '',
                refundStart: '',
                refundEnd: '',
                pageNum: 1,
                pageSize: 20
            },
            dateRange: [],
            total: 0,
            list: [],
            storelist: [],
            exporting: false
        }
    },
    created() {
        this.getList()
        this.getStoreList()
    },
    methods: {
        onDateChange(val) {
            if (val && val.length === 2) {
                this.queryInfo.refundStart = val[0]
                this.queryInfo.refundEnd = val[1]
            } else {
                this.queryInfo.refundStart = ''
                this.queryInfo.refundEnd = ''
            }
            this.getList()
        },
        async getList() {
            const { data: res } = await this.$http.get('quotabuyrefunds', { params: this.queryInfo })
            if (res.code === 0 || res.status === 0) {
                this.total = res.totalSize || 0
                this.list = res.data || []
            }
        },
        async getStoreList() {
            const { data: res } = await this.$http.get('store/')
            this.storelist = res.data || []
        },
        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize
            this.getList()
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage
            this.getList()
        },
        // 导出Excel
        exportExcel() {
            this.exporting = true
            let downloadLoadingInstance = Loading.service({
                text: "正在下载数据，请稍候",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            })
            axios
                .get("/quotabuyrefunds/export", {
                    responseType: "blob",
                    params: {
                        orderNo: this.queryInfo.orderNo,
                        storeId: this.queryInfo.storeId,
                        refundStart: this.queryInfo.refundStart,
                        refundEnd: this.queryInfo.refundEnd
                    }
                })
                .then(async (data) => {
                    this.exporting = false
                    const isBlob = data.data.type !== "application/json"
                    if (isBlob) {
                        const blob = new Blob([data.data])
                        saveAs(blob, `额度购买退款记录_${new Date().getTime()}.xlsx`)
                    } else {
                        this.$message.error("导出额度购买退款记录失败")
                    }
                    downloadLoadingInstance.close()
                })
                .catch((r) => {
                    this.exporting = false
                    console.error(r)
                    this.$message.error("下载文件出现错误，请联系管理员！")
                    downloadLoadingInstance.close()
                })
        }
    }
}
</script>
